import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { useInView, revealClass } from "../../hooks/useInView";

const FAQS = [
  { q: "Ist die Schrottabholung wirklich kostenlos?", a: "Ja. Wir holen Eisen, Stahl, Kupfer, Messing, Alu und andere Metalle in Bremen und Umgebung kostenlos bei Ihnen ab. Keine Anfahrtspauschale, keine versteckten Kosten." },
  { q: "Wie schnell könnt ihr kommen?", a: "In der Regel innerhalb von 24–72 Stunden. Bei dringenden Fällen oft auch noch am selben Tag – einfach kurz per WhatsApp anfragen." },
  { q: "Was kostet eine Haushaltsauflösung?", a: "Das hängt von Umfang, Etage und Verwertbarkeit ab. Wir machen Ihnen nach einer kurzen Besichtigung oder anhand von Fotos einen festen Preis – transparent und ohne Überraschungen." },
  { q: "Räumt ihr auch Messie-Wohnungen?", a: "Ja, absolut diskret und respektvoll. Wir haben Erfahrung mit stark verwahrlosten Wohnungen – ohne Bewertung, ohne Vorurteile." },
];

export const FAQ = () => {
  const [headRef, headIn] = useInView();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-16 md:py-24 bg-white border-t border-black/8"
    >
      <div className="px-4 md:px-8 lg:px-12 grid lg:grid-cols-12 gap-8 lg:gap-12">
        <div ref={headRef} {...revealClass(headIn)} className="lg:col-span-5">
          <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-black/45">
            · 07 — Häufige Fragen
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-[68px] font-semibold tracking-[-0.04em] leading-[1.02] text-black">
            FAQ.
            <br />
            <span className="text-black/35">Klare Antworten.</span>
          </h2>
          <p className="mt-5 text-black/60 max-w-md">
            Sie haben eine Frage, die hier nicht steht? Schreiben Sie uns per
            WhatsApp – wir antworten schnell und ehrlich.
          </p>
        </div>
        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="rounded-3xl bg-white border border-black/8 divide-y divide-black/8 overflow-hidden">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-none"
              >
                <AccordionTrigger className="px-6 py-5 hover:no-underline hover:bg-black/[0.03] text-left text-base md:text-lg font-medium text-black">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 text-sm text-black/65 leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
